// extracted by mini-css-extract-plugin
export var currencyInput = "_o4-1";
export var currencySymbol = "_o4-0";